import { ArrowCounterClockwise } from "@phosphor-icons/react";

import { Button } from "common/components/ui/Button";

import NoConversationsImage from "assets/images/empty-placeholders/no-conversations.png";

interface NoResultsPlaceholderProps {
  hasKeywords: boolean;
  hasOtherFilters: boolean;
  clearFilters: () => void;
}

export default function NoResultsPlaceholder({
  hasKeywords,
  hasOtherFilters,
  clearFilters,
}: NoResultsPlaceholderProps) {
  let emptyPlaceholderSubtitle =
    "There were no results found for your search. Try searching for something else";

  if (hasOtherFilters && !hasKeywords) {
    emptyPlaceholderSubtitle = "No results found for selected filters";
  }

  return (
    <div className="flex flex-col p-6 m-auto items-center">
      <img
        src={NoConversationsImage}
        alt=""
        width={216}
        height={140}
        className="mb-4"
      />
      <h5 className="text-center text-sm-bold mb-0.5">No results found</h5>
      <p className="text-xs-medium text-black-500 mb-4 text-center">
        {emptyPlaceholderSubtitle}
      </p>
      <Button
        leftIcon={<ArrowCounterClockwise />}
        variant="outline-black"
        onClick={clearFilters}
        size="sm"
      >
        Clear {hasOtherFilters ? "all filters" : "search"}
      </Button>
    </div>
  );
}
